export function formatPrice(price: number | undefined | null) {
  if (typeof price === "number" && !Number.isInteger(price)) {
    return price.toFixed(2).replace(".", ",");
  }

  return price?.toString() + ",-";
}
